import React from 'react';

import './DividingLine.sass';

export const DividingLine = () => <div className="dividing-line" />;
